
import { components } from 'react-select'

export const DropdownIndicator = props => 
<components.DropdownIndicator {...props}>
    <img alt='search' src={require('../../assets/img/icons/Search.svg').default} height="24px" />
</components.DropdownIndicator>